module.exports = __webpack_public_path__ + "9d7b5846d999f43ae13a6936c3eaebcc.svg";